import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import SearchBox from "@/components/feature/SearchBox";

const navLinks = [
  { to: "/", label: "首页" },
  { to: "/works", label: "影视作品" },
  { to: "/stars", label: "明星资讯" },
  { to: "/news", label: "影视动态" },
  { to: "/about", label: "关于我们" },
  { to: "/contact", label: "联系我们" },
];

export default function Navbar() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const isHome = location.pathname === "/";
  const transparent = isHome && !scrolled && !menuOpen;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const linkBase = "relative whitespace-nowrap px-3 py-2 text-sm font-medium transition-colors";

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 w-full transition-colors duration-300 ${
        transparent
          ? "bg-transparent"
          : "border-b border-background-200 bg-background-50/95 backdrop-blur"
      }`}
    >
      <div className="mx-auto flex h-16 w-full items-center gap-4 px-4 md:h-[72px] md:px-6">
        <Link to="/" className="flex shrink-0 items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 font-heading text-lg font-black text-foreground-950">
            朝
          </span>
          <span className="flex flex-col leading-none">
            <span
              className={`font-heading text-lg font-black tracking-wide transition-colors ${
                transparent ? "text-background-50" : "text-foreground-950"
              }`}
            >
              朝桐光
            </span>
            <span
              className={`text-[10px] tracking-[0.25em] transition-colors ${
                transparent ? "text-background-200" : "text-foreground-500"
              }`}
            >
              FILM STUDIO
            </span>
          </span>
        </Link>

        <nav className="ml-4 hidden items-center lg:flex">
          {navLinks.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.to === "/"}
              className={({ isActive }) =>
                `${linkBase} ${
                  transparent
                    ? isActive
                      ? "text-accent-400"
                      : "text-background-100 hover:text-accent-400"
                    : isActive
                      ? "text-primary-600"
                      : "text-foreground-700 hover:text-primary-600"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  {link.label}
                  {isActive && (
                    <span className="absolute inset-x-3 -bottom-0.5 h-0.5 rounded-full bg-accent-500" />
                  )}
                </>
              )}
            </NavLink>
          ))}
        </nav>

        <div className="ml-auto hidden lg:block">
          <SearchBox />
        </div>

        <button
          type="button"
          onClick={() => setMenuOpen((v) => !v)}
          aria-label="打开导航菜单"
          className={`ml-auto flex h-10 w-10 items-center justify-center rounded-md text-2xl lg:hidden ${
            transparent ? "text-background-50" : "text-foreground-900"
          }`}
        >
          <i className={menuOpen ? "ri-close-line" : "ri-menu-line"}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-6 pt-4 lg:hidden">
          <div className="mb-4">
            <SearchBox variant="mobile" />
          </div>
          <nav className="flex flex-col">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.to === "/"}
                className={({ isActive }) =>
                  `flex items-center justify-between rounded-md px-3 py-3 text-base font-medium transition-colors ${
                    isActive
                      ? "bg-primary-100 text-primary-700"
                      : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {link.label}
                <span className="flex h-4 w-4 items-center justify-center text-foreground-400">
                  <i className="ri-arrow-right-s-line"></i>
                </span>
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}